module.exports = __webpack_public_path__ + "img/logo-bue.224d5141.png";